
import { computed, defineComponent, PropType } from "vue";
import SpinnerAnimation from "@/components/SpinnerAnimation.vue";
import { css } from "@emotion/css";
import { useWidgetTheme } from "@/composables/widgetTheme";

export type ButtonType = "primary" | "secondary" | "alert" | "success";

export default defineComponent({
  props: {
    kind: {
      type: String as PropType<ButtonType>,
      default: "primary",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
  components: { SpinnerAnimation },
  setup(props) {
    const { theme } = useWidgetTheme();

    const buttonClass = computed(() => {
      switch (props.kind) {
        case "primary":
          return "btn-primary";

        case "secondary":
          return "btn-secondary";

        case "alert":
          return "btn-alert";

        case "success":
          return "btn-success";

        default:
          return "btn-primary";
      }
    });

    const themeClass = computed(() => {
      if (!["primary", "secondary"].includes(props.kind)) {
        return "";
      }

      return props.kind === "secondary"
        ? css`
            background-color: ${theme.value?.secondaryColor};
            color: ${theme.value?.secondaryTextColor};

            &:hover {
              background-color: ${theme.value?.secondaryColor};
              filter: brightness(85%);
            }
          `
        : css`
            background-color: ${theme.value?.primaryColor};
            color: ${theme.value?.primaryTextColor};

            &:hover {
              background-color: ${theme.value?.primaryColor};
              filter: brightness(85%);
            }
          `;
    });

    return {
      buttonClass,
      themeClass,
    };
  },
});
